/* eslint-disable @typescript-eslint/no-explicit-any */

/**
 * 클래스 기반 타입 가드
 * @param value unknown
 * @param constructor class
 */
export function isInstanceOf<T>(
  value: unknown,
  constructor: new (...args: any[]) => T,
): value is T {
  return value instanceof constructor;
}

/**
 * JS 기본 Error 또는 확장 Error 여부
 * @param value unknown
 */
export function isError(value: unknown): value is Error {
  return (
    typeof value === 'object' &&
    value !== null &&
    'name' in value &&
    'message' in value &&
    typeof (value as any).name === 'string' &&
    typeof (value as any).message === 'string'
  );
}

/**
 * 특정 키를 가진 객체인지 확인 (lightweight 구조 판단용)
 * @param value unknown
 * @param keys T[]
 */
export function hasKeys<T extends string>(value: unknown, keys: T[]): value is Record<T, unknown> {
  return typeof value === 'object' && value !== null && keys.every(key => key in value);
}

/**
 * 배열인지 + 배열 내부가 특정 타입인지 확인
 */
export function isArrayOf<T>(arr: unknown, predicate: (item: unknown) => item is T): arr is T[] {
  return Array.isArray(arr) && arr.every(predicate);
}
